import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';


/* global customElements */
class CustomTemplateGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var customTemplateGrid = this;
		setTimeout(function(){
			customTemplateGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var customTemplateGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					value: 'ALL',
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							},
							{
								code: 'P',
								desc: 'Pending'
							},
							{
								code: 'ALL',
								desc: 'All'
							}
						];						
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},				
				{
					tag: 'span',
					innerHTML: '|'
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_REPORT_TEMPLATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_REPORT_TEMPLATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'import',
					'class': 'spacer-toolbar-item',						
					permissions: ['ADMIN_REPORT_TEMPLATES:WRITE'],						
					children:[
						ElementUtil.makeIcon('vaadin:upload', ' Attach Template')						
					],
					listeners: {
						click: function() {
							actionImport(grid.selectedItems[0]);
						}
					}							
				},
				{
					tag: 'dl-action-button',
					itemid: 'export',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_REPORT_TEMPLATES:READ'],						
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download Template')						
					],
					listeners: {
						click: function() {
							actionDownload(grid.selectedItems[0]);
						}
					}								
				},	
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'toggleStatus',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_REPORT_TEMPLATES:UPDATE_STATUS'],						
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')						
					],
					listeners: {
						click: function() {
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}								
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['ADMIN_REPORT_TEMPLATES:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}							
						}
					]
				}				
			]
		});
				
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{						
					path: 'templateId',
					header: 'Template Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Name',
					width: '9em'
				},	
				{						
					path: 'description',
					header: 'Description',
					width: '9em'
				},				
				{						
					path: 'dataSourceReportType',
					header: 'Data Source',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'templateFileName',
					header: 'Template File Name',					
					width: '7em'
				},
				{						
					path: 'activeStatus',
					header: 'Active Status',					
					width: '7em'
				},
				{						
					path: 'updateUser',					
					header: 'Update User',					
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Dts',
					width: '14em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.updateDts) {
							var date = TimeUtil.parseDate(rowData.item.updateDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				}		
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'toggleStatus').disabled = false;
						ElementUtil.query(toolbar, 'import').disabled = false;
						if (grid.selectedItems[0].templateFileName) {
							ElementUtil.query(toolbar, 'export').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'export').disabled = true;
						}
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'toggleStatus').disabled = true;
						ElementUtil.query(toolbar, 'import').disabled = true;
						ElementUtil.query(toolbar, 'export').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}					
				}
			}
		});	
				
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						
						grid.currentFilter = {
							offset: pageRange.offset,
							limit: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'name',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC'
						};
						
						var status = ElementUtil.query(toolbar, 'status').value;
						if (status) {
							grid.currentFilter.status = status;
						}
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
														
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();

						};
																						
						Service.getReportService().getTemplateReports(grid.currentFilter).then(function(records) {								
							successHandler(records);
						}, function(){
							loadMask.remove();
						});
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'dl-custom-report-templates-page.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		customTemplateGrid.append(flexLayout);		
			
		var actionRefresh = function () {
			pagingToolbar.loadPage(1);				
		};
		
		var actionAddEdit = function (record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Template' : 'Add Template',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [		
										{
											tag: 'vaadin-text-field',
											itemid: 'name',
											label: 'Name',
											name: 'name',
											required: true											
										},
										{
											tag: 'vaadin-text-field',
											itemid: 'description',
											label: 'Description',
											name: 'description',
											required: true											
										},
										{
											tag: 'vaadin-number-field',
											itemid: 'version',
											label: 'Version',
											name: 'version',
											required: true
										},
										{
											tag: 'vaadin-text-field',
											itemid: 'reportFileName',
											label: 'Report Filename',
											name: 'reportFileName',
											required: true
										},
										{
											tag: 'vaadin-text-field',
											itemid: 'category',
											label: 'Category',
											name: 'category',									
											required: true
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Data Source',
											name: 'dataSourceReportType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getReportService().getTemplateAvailableReportTypes().then(function (data) {
													data.sort(function(a, b){
														return a.description.localeCompare(b.description);
													});
													combo.items = data;
													combo.required = true;
												});
											}
										},										
										{
											tag: 'vaadin-combo-box',
											label: 'Product',
											name: 'productCodes',
											'item-value-path': 'code',
											'item-label-path': 'description',													
											postinit: function (combo) {
												Service.getReportService().getTemplateAvailableProducts().then(function (data) {
													data.sort(function(a, b){
														return a.description.localeCompare(b.description);
													});
													combo.items = data;												
												});
											}
										},
										{
											tag: 'vaadin-combo-box',
											label: 'State',
											name: 'state',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {													
													combo.items = data;
												});
											}
										},										
										{
											tag: 'vaadin-combo-box',
											label: 'Permission',
											name: 'permission',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('SecurityPermission').then(function (data) {
													combo.items = data;													
												});
											}
										},										
										{
											tag: 'vaadin-combo-box',
											label: 'Report Visibilty',
											name: 'reportVisibiltyType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: 'COMPANY',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('ReportVisibilityType').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {			
																																																					
															formPanel.submitForm({																
																preSubmit: function(data) {																																																
																	return data;
																},
																actualCall: function(data) {						
																	if (record) {
																		data.templateId = record.templateId;
																	}																	
																	return Service.getReportService().saveTemplateReport(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Template', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						
						if (record) {								
							//wait for render;shift to end of event loop
							setTimeout(function() {
								formPanel.load(record);																							
									
							});
						}
					}
				}
			});				
		};
		
		var actionImport = function (record) {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Template',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {
						uploadWin.show();

						var uploadHandler = function() {

							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A jasper report template file.');
							} else {
								uploadField.uploadFiles();
							}

						};

						var uploadFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-upload',
									itemid: 'uploadField',
									'no-auto':  true,
									'max-files': 1,
									required: true,
									target: '/api/resource/custom-report-templates/import/' + record.templateId,
									headers: ImportUtil.getUploadHeader(),
									listeners: {
										'upload-request': function(event) {
										},
										'upload-success': function(event) {
											var responseData = JSON.parse(event.detail.xhr.responseText);
											if (responseData.uploadFile) {
												//error
												window.DL.MessageUtil.showOkMessage(
													responseData.uploadFile + '<br>' +
													responseData.uploadFileType ? responseData.uploadFileType : ''
												);
											} else {								
												actionRefresh();
												uploadWin.close();
											}
										}
									}
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:upload', ' Upload')
													],
													listeners: {
														click: function() {
															if (uploadFormPanel.isValid()) {
																uploadHandler();
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															uploadWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						uploadWin.addToContentElement(uploadFormPanel);

					}
				}


			});			
		};
		
		var actionDownload = function (record) {					
			Service.getReportService().downloadTemplateReport(record.templateId);			
		};
		
		var actionDelete = function (record) {

			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + record.name + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function () {
							var loadMask = grid.showLoading('Removing...');

							Service.getReportService().deleteTemplateReport(record.templateId)
									.then(function () {
										loadMask.remove();
										window.DL.MessageUtil.showToast('Success', 'Removed: ' + record.name, {
											theme: 'success'
										});
										actionRefresh();
									});
						}
					},
					{
						text: 'No'
					}
				]
			});
		
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');
			var statusPromise;
			if (record.activeStatus === 'A') {
				statusPromise = Service.getReportService().inactivateTemplateReport(record.templateId);
			} else {
				statusPromise = Service.getReportService().activateTemplateReport(record.templateId);
			}
			statusPromise.then(function(){
				loadMask.remove();
				actionRefresh();
			}, function(){
				loadMask.remove();
			});
		};
		
	}
	
}
customElements.define('dl-custom-template-report-grid', CustomTemplateGrid);
